import React from 'react';
import { Flex, Text, Wrap, WrapItem, Button } from '@chakra-ui/react';
import ChatInput from './ChatInput';

interface WelcomeScreenProps {
  input: string;
  setInput: (value: string) => void;
  handleSendMessage: (message?: string) => void;
  isLoading: boolean;
  onKeyPress: (e: React.KeyboardEvent) => void;
  samplePrompts: string[];
}

const WelcomeScreen = ({
  input,
  setInput,
  handleSendMessage,
  isLoading,
  onKeyPress,
  samplePrompts,
}: WelcomeScreenProps): JSX.Element => (
  <Flex direction="column" align="center" justify="center" h="full" px={4} textAlign="center">
    <Text fontSize="2xl" fontWeight="medium" color="gray.800" mb={6} fontFamily="Lexend">
      Hi! I&apos;m Bureau GenAI. How can I help you discover our services today?
    </Text>
    <Wrap spacing={4} justify="center" maxW="800px" mb={8}>
      {samplePrompts.map(prompt => (
        <WrapItem key={prompt}>
          <Button
            size="md"
            variant="outline"
            colorScheme="blue"
            onClick={() => handleSendMessage(prompt)}
            fontSize="sm"
            fontWeight="normal"
            _hover={{ bg: 'blue.50' }}
            px={6}
            py={4}
            h="auto"
            whiteSpace="normal"
            textAlign="left"
          >
            {prompt}
          </Button>
        </WrapItem>
      ))}
    </Wrap>
    <Text fontSize="sm" color="gray.600" mb={4} fontFamily="Lexend">
      Or type your own question below
    </Text>
    <ChatInput
      input={input}
      setInput={setInput}
      handleSendMessage={() => handleSendMessage()}
      isLoading={isLoading}
      onKeyPress={onKeyPress}
    />
  </Flex>
);

export default WelcomeScreen;
